/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BillingCenter/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function BillingCenter({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/InsuredTreatments/Content/InsuredTreatment/Content/InsuredTreatmentItem/Payer/BillingCenter"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let txInsuredInsuranceSubscriptionInsurancePlanInsuranceBillingCenterNameValueData = fromData.useDataValue({ viewPath,
context: 'tx',
path: 'insured.insurance_subscription.insurance_plan.insurance_billing_center.name',
})
  return (<React.Fragment
>
<div
  data-testid="BillingCenter.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Billing Center:"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="tx.insured.insurance_subscription.insurance_plan.insurance_billing_center.name"
 text={txInsuredInsuranceSubscriptionInsurancePlanInsuranceBillingCenterNameValueData}
/>
</div>
{children}
</React.Fragment>)
}